import React from "react";
import styles from './Filter.module.css';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

import Buttons from '../Button/Button';



function Filter(props) {

  const [topic, TopicsetAlignment] = React.useState('left');
  const Topic = (event, TopicnewAlignment) => {
    TopicsetAlignment(TopicnewAlignment);
  };


  const [level, LevelsetAlignment] = React.useState('left');
  const Level = (event, LevelnewAlignment) => {
    LevelsetAlignment(LevelnewAlignment);
  };

  const [course, CoursesetAlignment] = React.useState('left');
  const Course = (event, CoursenewAlignment) => {
    CoursesetAlignment(CoursenewAlignment);
  };

  const [duration, DurationsetAlignment] = React.useState('left');
  const Duration = (event, DurationnewAlignment) => {
    DurationsetAlignment(DurationnewAlignment);
  };


  const [language, LanguagesetAlignment] = React.useState('left');
  const Language = (event, LanguagenewAlignment) => {
    LanguagesetAlignment(LanguagenewAlignment);
  };


  return (
    <div className={styles.FitlerContainer}>

      <div className={`${styles.ScrolleBox} ${"FilterBox"}`}>
      <div className={styles.FilterSection}>
        <h1>Topic</h1>
        <ToggleButtonGroup
          value={topic}
          exclusive
          onChange={Topic}
          aria-label="text alignment"
        >
          <ToggleButton value="Quran" aria-label="left aligned">
            <CheckRoundedIcon /> Quran
          </ToggleButton>

          <ToggleButton value="Hadith" aria-label="left aligned">
            <CheckRoundedIcon /> Hadith
          </ToggleButton>

          <ToggleButton value="Fiqh" aria-label="left aligned">
            <CheckRoundedIcon /> Fiqh
          </ToggleButton>

          <ToggleButton value="Salah" aria-label="left aligned">
            <CheckRoundedIcon /> Salah
          </ToggleButton>

          <ToggleButton value="Azan" aria-label="left aligned">
            <CheckRoundedIcon /> Azan
          </ToggleButton>

          <ToggleButton value="Philosophy" aria-label="left aligned">
            <CheckRoundedIcon /> Philosophy
          </ToggleButton>

          <ToggleButton value="IslamicFinance" aria-label="left aligned">
            <CheckRoundedIcon /> Islamic Finance
          </ToggleButton>

        </ToggleButtonGroup>
      </div>


      <div className={styles.FilterSection}>
        <h1>Level</h1>
        <ToggleButtonGroup
          value={level}
          exclusive
          onChange={Level}
          aria-label="text alignment"
        >
          <ToggleButton value="Beginner" aria-label="left aligned">
            <CheckRoundedIcon /> Beginner
          </ToggleButton>

          <ToggleButton value="Intermediate" aria-label="left aligned">
            <CheckRoundedIcon /> Intermediate
          </ToggleButton>

          <ToggleButton value="Advanced" aria-label="left aligned">
            <CheckRoundedIcon /> Advanced
          </ToggleButton>

          <ToggleButton value="Mixed" aria-label="left aligned">
            <CheckRoundedIcon /> Mixed
          </ToggleButton>


        </ToggleButtonGroup>
      </div>


      <div className={styles.FilterSection}>
        <h1>Course track</h1>
        <ToggleButtonGroup
          value={course}
          exclusive
          onChange={Course}
          aria-label="text alignment"
        >
          <ToggleButton value="Certificate" aria-label="left aligned">
            <CheckRoundedIcon /> Certificate
          </ToggleButton>

          <ToggleButton value="Diploma" aria-label="left aligned">
            <CheckRoundedIcon /> Diploma
          </ToggleButton>

        </ToggleButtonGroup>
      </div>


      <div className={styles.FilterSection}>
        <h1>Duration</h1>
        <ToggleButtonGroup
          value={duration}
          exclusive
          onChange={Duration}
          aria-label="text alignment"
        >
          <ToggleButton value="LessThan2Hours" aria-label="left aligned">
            <CheckRoundedIcon /> Less Than 2 Hours
          </ToggleButton>

          <ToggleButton value="Weeks" aria-label="left aligned">
            <CheckRoundedIcon /> 1-4 Weeks
          </ToggleButton>

          <ToggleButton value="Months" aria-label="left aligned">
            <CheckRoundedIcon /> 1-3 Months
          </ToggleButton>

          <ToggleButton value="Months" aria-label="left aligned">
            <CheckRoundedIcon /> Months
          </ToggleButton>

        </ToggleButtonGroup>
      </div>

      <div className={styles.FilterSection}>
        <h1>Language</h1>
        <ToggleButtonGroup
          value={language}
          exclusive
          onChange={Language}
          aria-label="text alignment"
        >
          <ToggleButton value="Arabic" aria-label="left aligned">
            <CheckRoundedIcon /> Arabic
          </ToggleButton>

          <ToggleButton value="Bengali" aria-label="left aligned">
            <CheckRoundedIcon /> Bengali
          </ToggleButton>

          <ToggleButton value="English" aria-label="left aligned">
            <CheckRoundedIcon /> English
          </ToggleButton>

          <ToggleButton value="Months" aria-label="left aligned">
            <CheckRoundedIcon /> Months
          </ToggleButton>

        </ToggleButtonGroup>
      </div>
      </div>

      <div className={styles.FilterFooter}>
        <Buttons
          label="Clear All"
          buttonColor="#fff"
          color="#0B132B"
          width="100%"
          height="48px"
          fontSize="14px"
          link=""
        //disabled="disabled"
        />

        <Buttons
          label="Apply"
          buttonColor="#004FE0"
          color="#fff"
          width="100%"
          height="48px"
          fontSize="14px"
          link=""
        //disabled="disabled"
        />
      </div>


    </div>
  );
}


export default Filter;

